import Swal from "sweetalert2";

export default {
  methods: {
    $confirm(title, text) {
      return Swal.fire({
        title,
        text,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
      }).then(({ value }) => {
        return value;
      });
    },
    $confirmMessage(title, text, inputPlaceholder) {
      return Swal.fire({
        title,
        text,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
        input: "text",
        inputPlaceholder,
      }).then(({ value }) => {
        return value;
      });
    },
  },
};
